import { IBranchPartner, IBranchPartnerFormPersistence, IBranchPartnerFormValues, IBranchPartnerPersistence } from '../interfaces';

export class BranchPartnersMapper {
  public static toDomain(branchPartner: IBranchPartnerPersistence): IBranchPartner {
    return {
      id: branchPartner.id,
      name: branchPartner.name,
      createdAt: branchPartner.created_at || '',
      description: branchPartner.descr,
      isOwner: !!branchPartner.is_owner,
      state: branchPartner.state_id ? { id: branchPartner.state_id, name: branchPartner.state_name } : null,
      contact: branchPartner.contact,
      hasIntegration: !!branchPartner.has_integration,
      integrationSlug: branchPartner.integration_slug ?? null,
    };
  }
}

export class CreateBranchPartnerMapper {
  public static toDomain(branchPartner: IBranchPartner): IBranchPartnerFormValues {
    return {
      id: branchPartner.id.toString(),
      name: branchPartner.name,
      description: branchPartner.description,
      isOwner: branchPartner.isOwner,
      contact: branchPartner.contact,
      stateId: branchPartner.state ? branchPartner.state.id.toString() : '',
    };
  }

  public static toPersistence(branchPartner: IBranchPartnerFormValues): IBranchPartnerFormPersistence {
    return {
      descr: branchPartner.description,
      name: branchPartner.name,
      is_owner: branchPartner.isOwner ? 1 : 0,
      contact: branchPartner.contact,
      state_id: branchPartner.stateId,
      company_id: branchPartner.id || '',
    };
  }
}

/** Server-side validation errors (snake_case) → Formik field errors. */
export class CreateBranchPartnerErrorsMapper {
  public static toDomain(errors: Record<string, string[]>): Record<string, string> {
    return {
      id: errors?.id?.join('. '),
      name: errors?.name?.join('. '),
      description: errors?.descr?.join('. '),
      isOwner: errors?.is_owner?.join('. '),
      contact: errors?.contact?.join('. '),
      stateId: errors?.state_id?.join('. '),
    } as Record<string, string>;
  }
}
